import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'denied',
    templateUrl: './denied.component.html',
    styleUrls: ['./denied.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DeniedComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}

